module.exports = __webpack_public_path__ + "img/pipeline.243b3216.png";